module.exports = __webpack_public_path__ + "img/mobile.0d5fe3cc.png";